import {
  Button,
  Filter,
  Loading,
  SearchBar,
  Typography,
} from "@kitbird/core";
import { useNavigate } from "react-router-dom";
import { HeaderText } from "../../../components/FloatHeader/FloatHeader.style";
import {
  CardContent,
  PageCard,
  PageWrapper,
  TitleContent,
} from "../../../components/Content/Content.style";
import BBLogo from "../../../assets/icons/logogram_bb.png";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plus.svg";
import { StickyTable } from "../../../components/Table/Table.style";
import Table from "../../../components/Table";
import { ActionSection } from "./BusinessTrx.styled";
import CreateEditBusinessTrx from "./components/CreateEditBusinessTrx";
import { BusinessTrxProvider, useBusinessTrx } from "./BusinessTrxProvider";
import ModalConfirmation from "../../../components/ModalConfirmation";

const BusinessTrxView = () => {
  const {
    action,
    columns,
    isFetching,
    isFetchingNextPage,
    businessTrxList,
    observerRef,
    setParams,
    meta,
    isEditMode,
    currentTrxFormValues,
    control,
    setValue,
    currentStep,
    setCurrentStep,
    formId,
    onCancelFormClick,
    onSubmitFormClick,
    previousStep,
    modal,
    setModal,
    handleSubmit,
    onFormSubmit,
    onFormError,
    handleDelete,
    filterConfigs,
    handleFilterSelect,
    selectedTrx,
  } = useBusinessTrx();
  const navigate = useNavigate();

  if (action) {
    return (
      <CreateEditBusinessTrx
        isEditMode={isEditMode}
        currentTrxFormValues={currentTrxFormValues}
        control={control}
        setValue={setValue}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        formId={formId}
        onCancelFormClick={onCancelFormClick}
        onSubmitFormClick={onSubmitFormClick}
        previousStep={previousStep}
        modal={modal}
        setModal={setModal}
        handleSubmit={handleSubmit}
        onFormSubmit={onFormSubmit}
        onFormError={onFormError}
      />);
  }
  return (
    <>
      <PageWrapper>
        <HeaderText>
          <Typography level={3} fontWeight="medium">
            Pendaftaran kode transaksi
          </Typography>
        </HeaderText>
        <PageCard>
          <CardContent>
            <TitleContent>
              <img src={BBLogo} width={40} alt="" />
              <Typography level={4} fontWeight="medium">
                Daftar kode transaksi
              </Typography>
            </TitleContent>
            <ActionSection>
              <div style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 9,
              }}>
                <SearchBar
                  data-testid="businessTrx-search-bar"
                  placeholder="Akun GL atau Deskripsi"
                  hasReset
                  onInputSearch={(value) => {
                    setParams((curr) => ({ ...curr, search: value }));
                  }}
                />
                {filterConfigs.map((filter) => (
                  <Filter
                    key={filter.paramKey}
                    isSearch={false}
                    label={filter.label}
                    width={135}
                    options={filter.options}
                    onSelected={(opt) => handleFilterSelect(filter.paramKey, opt)}
                    disabled={filter.disabled}
                  />
                ))}
              </div>
              <Button
                leftIcon={<PlusIcon />}
                onClick={() => navigate("?action=create")}
                style={{ minWidth: 154 }}
              >
                Tambah data
              </Button>
            </ActionSection>
            <StickyTable>
              {isFetching && !isFetchingNextPage
                ? <Loading variant="line" />
                : <Table
                  columns={columns}
                  withNumber
                  dataSource={businessTrxList}
                  footer={(
                    !isFetching && !isFetchingNextPage && meta.page < meta.total_pages
                      ? <tfoot ref={observerRef} style={{ height: 5, width: "100%" }} />
                      : undefined
                  )}
                />
              }
              {isFetchingNextPage && <Loading variant="circular" />}
            </StickyTable>
          </CardContent>
        </PageCard>
      </PageWrapper>
      {modal === "DELETE" && (
        <ModalConfirmation
          open
          onClose={() => setModal("")}
          title="Konfirmasi hapus data"
          message={
            <span>
              Apakah Anda yakin ingin menghapus data{" "}
              <strong>
                {selectedTrx?.pool_id} - {selectedTrx?.company_code} - {selectedTrx?.department}
              </strong>
              {" "}dari kode transaksi?
            </span>
          }
          action={{
            negativeBtn: {
              label: "Batal",
              onClick: () => setModal(""),
              show: true,
            },
            positiveBtn: {
              label: "Ya, hapus",
              destructive: true,
              onClick: () => handleDelete(),
              show: true,
            },
          }}
        />
      )}
    </>
  );
};

const BusinessTrx = () => (
  <BusinessTrxProvider>
    <BusinessTrxView />
  </BusinessTrxProvider>
);

export default BusinessTrx;
